import {
  STUDENT_TEST_BOOK,
  SCORING_WORKSHEET,
  SCORING_GUIDE,
} from 'legacy/src/constants/assessmentResourceTypes';

export const COPY_LINK = 'copy_link';
export const MARK_COMPLETE = 'mark_complete';
export const VIEW_RESULTS = 'view_results';
export const UPDATE_SETTINGS = 'update_settings';
export const MANAGE_ASSIGNMENT = 'manage_assignment';
export const GENERATE_ANSWERS_SHEETS = 'generate_answers_sheets';
export const DOWNLOAD_ANSWER_SHEETS = 'download_answer_sheets';
export const UPLOAD_ANSWER_SHEETS = 'upload_answer_sheets';
export const DELETE_ASSIGNMENT = 'delete_assignment';
export const PREVIEW = 'preview';
export const VIEW_SUMMARY = 'view_summary';
export const ASSIGN = 'assign';
export const REASSIGN = 'reassign';
export const DUPLICATE_QUIZ = 'duplicate_quiz';
export const EDIT_QUIZ = 'edit_quiz';
export const SHARE_QUIZ = 'share_quiz';
export const UPDATE_LABELS = 'update_labels';
export const DELETE_QUIZ = 'delete_quiz';
export const SHOW_HIDE_RESULTS_FOR_STUDENTS = 'show_hide_results_for_students';

export const ANSWER_SHEETS_ACTIONS = [
  GENERATE_ANSWERS_SHEETS,
  DOWNLOAD_ANSWER_SHEETS,
  UPLOAD_ANSWER_SHEETS,
];

export const RELATED_PDFS_ACTIONS = [
  STUDENT_TEST_BOOK,
  SCORING_GUIDE,
  SCORING_WORKSHEET,
];

export const getAssignmentActions = (
  isResultsOverviewPage,
  isAssignmentOverviewPage,
  isVideo,
  isSPP,
) =>
  isVideo
    ? [COPY_LINK, MARK_COMPLETE, UPDATE_SETTINGS, DELETE_ASSIGNMENT]
    : [
        COPY_LINK,
        MARK_COMPLETE,
        !isResultsOverviewPage && VIEW_RESULTS,
        UPDATE_SETTINGS,
        (isResultsOverviewPage || isAssignmentOverviewPage) &&
          SHOW_HIDE_RESULTS_FOR_STUDENTS,
        !isAssignmentOverviewPage && MANAGE_ASSIGNMENT,
        ...(!isSPP ? ANSWER_SHEETS_ACTIONS : []),
        DELETE_ASSIGNMENT,
      ];

export const ASSIGNED_RESOURCE_MY_QUIZ_RESOURCE_ACTIONS = [
  PREVIEW,
  VIEW_SUMMARY,
  ASSIGN,
  REASSIGN,
  DUPLICATE_QUIZ,
  EDIT_QUIZ,
  SHARE_QUIZ,
  UPDATE_LABELS,
  DELETE_QUIZ,
  STUDENT_TEST_BOOK,
  SCORING_GUIDE,
];

export const ASSIGNED_RESOURCE_PROGRESS_CHECK_RESOURCE_ACTIONS = [
  PREVIEW,
  VIEW_SUMMARY,
  ASSIGN,
  REASSIGN,
  UPDATE_LABELS,
  STUDENT_TEST_BOOK,
  SCORING_GUIDE,
];

export const ASSIGNED_RESOURCE_STUDENT_PRACTICE_RESOURCE_ACTIONS = [
  PREVIEW,
  ASSIGN,
  REASSIGN,
  UPDATE_LABELS,
];

export const ASSIGNED_RESOURCE_PRACTICE_EXAM_RESOURCE_ACTIONS = [
  PREVIEW,
  VIEW_SUMMARY,
  ASSIGN,
  REASSIGN,
  UPDATE_LABELS,
  DUPLICATE_QUIZ,
  STUDENT_TEST_BOOK,
  SCORING_GUIDE,
  SCORING_WORKSHEET,
];

export const getResourceActions = (
  isPPC,
  isSPP,
  isPE,
  isVideo,
  isMyQuiz,
  isAllResourcesPage,
  isLC = false,
  isPT = false,
) => {
  if (isPPC || isLC) {
    return ASSIGNED_RESOURCE_PROGRESS_CHECK_RESOURCE_ACTIONS;
  }
  if (isSPP) {
    return ASSIGNED_RESOURCE_STUDENT_PRACTICE_RESOURCE_ACTIONS;
  }
  if (isPE || isPT) {
    return ASSIGNED_RESOURCE_PRACTICE_EXAM_RESOURCE_ACTIONS;
  }
  if (isVideo) {
    return [ASSIGN, REASSIGN, UPDATE_LABELS, isAllResourcesPage && PREVIEW];
  }
  if (isMyQuiz) {
    return ASSIGNED_RESOURCE_MY_QUIZ_RESOURCE_ACTIONS;
  }

  return [];
};
